var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sp-txt-component",style:(_vm.sectionStyle),attrs:{"id":_vm.componentId}},[_c('div',{staticClass:"sp-txt-content"},[_c('span',{staticClass:"sp-txt-text",style:(_vm.textStyle),domProps:{"innerHTML":_vm._s(_vm.formattedText)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }